import React from 'react';
import {Animated, Platform, View} from 'react-native';
import {noop} from 'lodash';

import {PieChart as BasePieChart} from '/component/base/PieChart';
import Text from '/component/base/Text';
import {BonusesID} from '/constant/TestIDs';

import {NO_VALUE} from '../Bonuses.hook';

import {usePieChart} from './PieChart.hook';
import {
  PIE_CHART_HEIGHT,
  PIE_CHART_INNER_RADIUS,
  styles,
} from './PieChart.style';
import {PieChartProps} from './PieChart.types';

export const PieChart = ({
  data = [],
  onPress = noop,
  colorScale = [],
  totalBonus = 0,
  selectedTileIndex = NO_VALUE,
  externalMutations = [],
}: PieChartProps) => {
  const {
    tt,
    onLayout,
    formattedItemsForPie,
    marginAnimation,
    percent,
    bonusDescription,
  } = usePieChart({data, totalBonus, selectedTileIndex});

  return (
    <View style={styles.base} testID={BonusesID.bonusesPieChart}>
      <BasePieChart
        // @ts-expect-error TS(2322): Type '{ padAngle: number; onPress: any; colorScale... Remove this comment to see the full error message
        padAngle={0.4}
        onPress={onPress}
        colorScale={colorScale}
        height={PIE_CHART_HEIGHT}
        width={PIE_CHART_HEIGHT}
        data={formattedItemsForPie}
        selectedIndex={selectedTileIndex}
        innerRadius={PIE_CHART_INNER_RADIUS}
        style={{
          labels: styles.pieChartLabels,
          data: {
            cursor: Platform.OS === 'web' ? 'pointer' : 'auto',
            WebkitTapHighlightColor: 'transparent',
            // @ts-ignore
            outline: 'none',
          },
        }}
        containerStyle={styles.pieChartContainer}
        externalEventMutations={externalMutations}
      />
      <Animated.View
        style={[styles.pieChartInner, {marginTop: marginAnimation}]}
        onLayout={onLayout}>
        {percent ? (
          <View style={styles.percentContainer}>
            <Text
              variant="large"
              testID={BonusesID.bonusesChartSelectedPercentage}>
              {percent}
              <Text variant="heading">%</Text>
            </Text>
            <Text
              variant="body"
              style={styles.centeredText}
              testID={BonusesID.bonusesChartSelectedDescription}>
              {bonusDescription}
            </Text>
          </View>
        ) : (
          <Text
            variant="body"
            style={styles.centeredText}
            testID={BonusesID.bonusesChartDefaultText}>
            {tt('totalBonusesBreakdown', 'Total bonuses breakdown')}
          </Text>
        )}
      </Animated.View>
    </View>
  );
};
